/**
 * Shared form-field class bundles.
 *
 * `REQUIRED_EMPTY_BORDER` — red border for a REQUIRED field that is currently empty.
 * The app's convention for flagging a mandatory-but-blank field (mirrors the
 * order-title / sales-origin red underline). Clears as soon as the field has a value.
 * The `!` prefixes override the component's own default border colour, so it can be
 * appended to an Input / NumberInput / Textarea / DropdownSelect className.
 */
export const REQUIRED_EMPTY_BORDER = '!border-red-400 dark:!border-red-500/70';
